// Bootstrap4 + FontAwesome Icon
export default {

  table: {
    tableHeaderClass: 'fixed',
    tableClass: 'table table-sm  table-borderless table-hover',
    loadingClass: 'loading',
    ascendingIcon: 'glyphicon glyphicon-chevron-up',
    descendingIcon: 'glyphicon glyphicon-chevron-down',
    handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  pagination: {
    paginationClass: 'pull-left',
    wrapperClass: 'vuetable-pagination pull-right',
    activeClass: 'btn-primary',
    disabledClass: 'disabled',
    pageClass: 'btn btn-border ',
    linkClass: 'btn btn-border ',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: '',
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/presentation/table/vuetablecss.js